import { storagePrefixV2 } from '@/constant';

export const BODY_BG: Record<Customer.Gender, { front?: string; back: string }> = {
  Male: {
    front: storagePrefixV2 + '/immer-mode/asasfasf-bg.png',
    back: storagePrefixV2 + '/immer-mode/qwdqwfqw.png',
  },
  Female: {
    front: storagePrefixV2 + '/immer-mode/qwfqwfgasda.png',
    back: storagePrefixV2 + '/immer-mode/zqsdasdqwd.png',
  },
};

export const VIDEO_URLS: Record<Massage.MassageItem, typeof BODY_BG> = {
  Shockwave: {
    Male: {
      back: storagePrefixV2 + '/immer-mode/videos/v2/sw-male-back-v2.mp4',
    },
    Female: {
      back: storagePrefixV2 + '/immer-mode/videos/v2/sw-female-back-v2.mp4',
    },
  },
  Moxibustion: {
    Male: {
      front: storagePrefixV2 + '/immer-mode/videos/v2/mox-male-front-v2.mp4',
      back: storagePrefixV2 + '/immer-mode/videos/v2/mox-male-back-v2.mp4',
    },
    Female: {
      front: storagePrefixV2 + '/immer-mode/videos/v2/mox-female-front-v2.mp4',
      back: storagePrefixV2 + '/immer-mode/videos/v2/mox-female-back-v2.mp4',
    },
  },
  Massage: {
    Male: {
      back: storagePrefixV2 + '/immer-mode/videos/massage-male.mp4',
    },
    Female: {
      back: storagePrefixV2 + '/immer-mode/videos/massage-female.mp4',
    },
  },
  RadioFrequency: {
    Male: {
      front: storagePrefixV2 + '/immer-mode/videos/rf-male-front.mp4',
      back: storagePrefixV2 + '/immer-mode/videos/rf-male-back.mp4',
    },
    Female: {
      front: storagePrefixV2 + '/immer-mode/videos/rf-female-front.mp4',
      back: storagePrefixV2 + '/immer-mode/videos/rf-female-back.mp4',
    },
  },
  HotStone: {
    Male: {
      front: storagePrefixV2 + '/immer-mode/videos/rf-male-front.mp4',
      back: storagePrefixV2 + '/immer-mode/videos/rf-male-back.mp4',
    },
    Female: {
      front: storagePrefixV2 + '/immer-mode/videos/rf-female-front.mp4',
      back: storagePrefixV2 + '/immer-mode/videos/rf-female-back.mp4',
    },
  },
};
